module.exports = __webpack_public_path__ + "img/UT0390.893da604.png";